// extracted by mini-css-extract-plugin
export default {"wrapper":"ADSContentRight_wrapper__U1VCX"};